import React, { Component, Fragment } from 'react'

import { Button, Container, Row, Col} from 'react-bootstrap'

import '../../asset/css/custom.css';
import '../../asset/css/bootstrap.min.css';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import myPhoto from '../../asset/image/novo.jpg';
export class Events extends Component {
  render() {
    return (
      <Fragment>
        <Container fluid={true} className='EventBB text-center' p-0>
           <h1 className='h1Tag'>Upcoming Events</h1>
              <div className='bottom'></div>


               <div className="card-group">
      <div className="card">
        <img src={myPhoto} alt="Card 1" className="card-img" />
        <div className="card-body">
          <h3 className="card-title">Card One</h3>
          <p className="card-text">
            This is a wider card with supporting text below as a natural lead-in
            to additional content. This content is a little bit longer.
          </p>
        </div>
        <div className="card-footer">
          <small> <Button variant='primary'>Learn More</Button></small>
        </div>
      </div>
      
          <div className="card">
        <img src={myPhoto} alt="Card 2" className="card-img" />
        <div className="card-body">
          <h3 className="card-title">Card Two</h3>
          <p className="card-text">
            This card has supporting text below as a natural lead-in to
            additional content.
          </p>
        </div>
        <div className="card-footer">
          <small><Button variant='primary'>Learn More</Button></small>
        </div>
      </div>

      <div className="card">
        <img src={myPhoto} alt="Card 3" className="card-img" />
        <div className="card-body">
          <h3 className="card-title">Card Three</h3>
          <p className="card-text">
            This is a wider card with supporting text below as a natural lead-in
            to additional content. This card has even longer content than the
            first to show equal height action.
          </p>
        </div>
        <div className="card-footer">
          <small><Button variant='primary'>Learn More</Button></small>
        </div>
      </div>
      
      <div className="card">
        <img src={myPhoto} alt="Card 3" className="card-img" />
        <div className="card-body">
          <h3 className="card-title">Card Three</h3>
          <p className="card-text">
            This is a wider card with supporting text below as a natural lead-in
            to additional content. This card has even longer content than the
            first to show equal height action.
          </p>
        </div>
        <div className="card-footer">
          <small><Button variant='primary'>Learn More</Button></small>
        </div>
      </div>






      </div>









        </Container>
      </Fragment>
    )
  }
}

export default Events
